import Highcharts from 'highcharts';
import Heatmap from 'highcharts/modules/heatmap';
// Use Treemap module from highcharts
Heatmap(Highcharts);
export default Highcharts;
